module.exports = __webpack_public_path__ + "img/agpz-train-disabled.7f226aab.svg";